const config = {
    misskeyFetchLimit: 100
};

export default config;
